<template>
  <div class="fertig-step">
      <p class="text-err font-weight-bold mb-4">
        {{ text.thx_booking }}
      </p>
      <div class="etermin-step contact pb-5">
        <div class="form-wrapper row rows row-s">
          <div class="col-12 col-lg pe-lg-2 pb-lg-4 pb-2">
            <form class="v-form w-100 seconda bg-secondary-l h-100 border-radius-main p-lg-8 p-4 mb-lg-0 mb-4">
              <div class="v-form-title-container border-l-bottom-white mb-4">
                <h3 class="v-form-title mb-5 mt-0 text-left">
                  {{ text.your_data }}
                </h3>
              </div>
              <div class="form-container py-5">
                <div class="v-input-wrapper position-relative v-dropdown mb-3">
                  <div class="v-input p-1 border-radius-main bg-white border-0 p text-left w-100 final-result">
                    <p class="result-final-title text-gray-d text-ss font-weight-600">
                      {{ text.salutation }}
                    </p>
                    <p class="result-final-input text-s font-weight-600">{{ (appointement.contact.salutation == 'mr') ? 'Herr' : ' Frau' }}</p>
                  </div>
                </div>
                <div class="vornach d-flex flex-row">
                  <div class="v-input-wrapper position-relative flex-1 vor w-100 me-1 mb-3">
                    <div class="v-input border-radius-main bg-white border-0 p text-left w-100 p-1">
                      <p class="result-final-title text-gray-d text-ss font-weight-600">
                        {{ text.first_name }}
                      </p>
                      <p class="result-final-input text-s font-weight-600">{{ appointement.contact.firstname }}</p>
                    </div>
                  </div>

                  <div class="v-input-wrapper position-relative flex-1 nach w-100 ms-1 mb-3">
                    <div class="v-input border-radius-main bg-white border-0 p text-left w-100 p-1">
                      <p class="result-final-title text-gray-d text-ss font-weight-600">
                        {{ text.last_name }}
                      </p>
                      <p class="result-final-input text-s font-weight-600">{{ appointement.contact.lastname }}</p>
                    </div>
                  </div>
                </div>

                <div class="v-input-wrapper position-relative mb-3">
                  <div class="v-input border-radius-main bg-white border-0 p text-left w-100 p-1">
                    <p class="result-final-title text-gray-d text-ss font-weight-600">
                      {{ text.phone }}
                    </p>
                    <p class="result-final-input text-s">{{ appointement.contact.telephone }}</p>
                  </div>
                </div>

                <div class="v-input-wrapper position-relative mb-3">
                  <div class="v-input border-radius-main bg-white border-0 p text-left w-100 p-1">
                    <p class="result-final-title text-gray-d text-ss font-weight-600">
                      {{ text.email }}
                    </p>
                    <p class="result-final-input text-s">{{ appointement.contact.email }}</p>
                  </div>
                </div>
                <div class="v-input-wrapper position-relative">
                  <div class="v-input border-radius-main bg-white border-0 p text-left w-100 p-1">
                    <p class="result-final-title text-gray-d text-ss">
                      {{ text.remarks }}
                    </p>
                    <p class="result-final-input text-s">{{ appointement.contact.description }}</p>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="col-12 col-lg ps-lg-2 pb-lg-4 pb-2">
            <div class="v-side text-left bg-secondary-l h-100 border-radius-main p-lg-8 p-4">
              <div class="v-side-title-container">
                <h3 class="v-side-title pb-5 mt-0 text-left border-l-bottom-white mb-5">
                  {{ text.summary }}
                </h3>
              </div>
              <div class="v-side-container">
                <div class="d-flex">
                  <h4 class="mb-2 v-sub-title">
                    {{ text.store }}
                  </h4>
                </div>
                <div class="result mb-5 v-flex justify-content-between v-side-result border-radius-main line-1 bg-white p-4">
                  <div class="result-left">
                    <h4 class="font-weight-bold mb-1 line-1 p">{{ selectedStore.title }}</h4>
                    <p class="m-0 text-s font-weight-600">{{ selectedStore.address }}</p>
                    <p class="m-0 text-s font-weight-600">{{ selectedStore.zip }} {{ selectedStore.city }}</p>
                    <p class="m-0 text-s font-weight-600">{{selectedStore.phone }}</p>
                  </div>
                </div>
                <div class="d-flex">
                  <h4 class="mb-2 v-sub-title">
                    {{ text.date_time }}
                  </h4>
                </div>
                <div class="result mb-5 v-flex justify-content-between v-side-result border-radius-main line-1 bg-white p-4">
                  <div class="result-left">
                    <p class="m-0 font-weight-bold text-s">{{ getDate(appointement.date) }}</p>
                    <p class="m-0 font-weight-bold text-s">{{ appointement.time}} - {{ getAppointementEnd(appointement.services[0],appointement.date, appointement.time) }} Uhr</p>
                  </div>

                </div>
                <div class="d-flex">
                  <h4 class="mb-2 v-sub-title">
                    {{ text.services }}
                  </h4>
                </div>
                <div class="result mb-5 v-flex justify-content-between v-side-result border-radius-main line-1 bg-white p-4">
                  <div class="result-left">
                    <div v-for="(item, index) in appointement.services" :key="item.id" v-bind:class="{ 'mb-2': index <= appointement.services.length - 2 }" class="service-item d-flex align-items-center">
                      <img class="me-2" :src="getServiceImage(item)" width="25"/>
                      <p class="font-weight-bold text-s" v-html="getServiceName(item)"></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>

</template>

<script>
import { mapState, mapGetters } from 'vuex'
import moment from 'moment'
import ServiceDrupal from '@/services/ServiceDrupal.js'

moment.locale('de')

export default {
    name: 'fertig-step',
    props: {
        appointement: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            id: 3,
            text: {
                thx_booking: Drupal.t('Thank you for your booking. Your booking confirmation will be sent to you by email. Please also check your spam folder.'),
                your_data: Drupal.t('Your data'),
                salutation: Drupal.t('Salutation'),
                first_name: Drupal.t('First name'),
                last_name: Drupal.t('Last name'),
                phone: Drupal.t('Phone'),
                email: Drupal.t('E-Mail'),
                remarks: Drupal.t('Remarks'),
                summary: Drupal.t('Summary'),
                store: Drupal.t('Store'),
                date_time: Drupal.t('Date & Time'),
                services: 'Services' // no translation needed
            }
        }
    },
    computed: {
        ...mapGetters('etermin', ['getServiceName']),
        ...mapGetters('etermin', ['getActiveStep']),
        ...mapGetters('etermin', ['getServiceImage']),
        ...mapGetters('etermin', ['getAppointementEnd']),
        ...mapGetters('etermin', ['getTime']),
        ...mapGetters('etermin', ['getDate']),
        ...mapState({
            steps: state => state.etermin.steps
        }),
        ...mapState([
            'selectedStore'
        ])
    },
    mounted () {
        this.$emit(`mounted`)

        const service = this.appointement.services[0];
        // Google Tag-Manager push 'appointment booking submit' to dataLayer
        if (window.dataLayer) {
            window.dataLayer.push({
                event: `booking`,
                event_type: `submit`,
                appointment_type: service !== 'undefined' ? this.getServiceName(service) : '',
                event_data: {}
            })
        }
    }
}
</script>

<style lang="css" scoped>

</style>
